import React from 'react';
import { Form, Field } from 'react-final-form';
import styled from 'styled-components';

import ModalButtons from 'components/ModalButtons';
import SForm from './styled';
import CustomInput from './components/CustomInput';

const SField = styled.div`
  padding-bottom: 16px;
`;

type Props = {
  loading: boolean;
  onSubmit: (commitMessage: string) => void;
  onCancel: () => void;
};

const CommitForm = ({ onSubmit, onCancel, loading }: Props) => (
  <Form
    onSubmit={({ commit }) => {
      onSubmit(commit);
    }}
  >
    {({ handleSubmit, values }) => (
      <SForm data-test="commit-push-form" onSubmit={handleSubmit}>
        <SField>
          <Field
            autoFocus
            component={CustomInput}
            label="Commit"
            name="commit"
            placeholder="Summarize your changes..."
          />
        </SField>
        <ModalButtons
          primary={{
            text: 'Confirm',
            type: 'submit',
            disabled: !values.commit,
            loading,
          }}
          secondary={{ text: 'Cancel', onClick: onCancel }}
        />
      </SForm>
    )}
  </Form>
);

export default CommitForm;
